import axios from 'axios';

const cmsApi = axios.create({
    baseURL: process.env.VUE_APP_CMS_API,
    timeout: 10000000,
});

// Request interceptor
cmsApi.interceptors.request.use((config) => {
    let lang = localStorage.getItem('x-lang');
    if (!lang) {
        localStorage.setItem('x-lang', 'id');
        lang = 'id';
    }

    const token = localStorage.getItem('auth_token');

    config.headers = {
        'X-LANG': lang,
        'X-KEY': process.env.VUE_APP_KEY,
        ...config.headers,
    };

    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
});

// Response interceptor
cmsApi.interceptors.response.use(
    (response) => response,
    (error) => {
        return Promise.reject(error);
    },
);

export default cmsApi;
